<template lang="html">
  <Form :label-width="size || 140">
    <FormItem label="Nome">
      <Input v-model="centro_form.name" :disabled="!$store.config.IS_LOCAL"/>
    </FormItem>
    <FormItem label="Logo">
      <input type="file" ref="file"/>
      <canvas ref="logo_preview"  height="0" style="width: 100%"></canvas>
      <img v-if="!centro_form.logo" :src="`${$store.config.API_URL}/logo/${$store.company.id}`" style="width:100%">
    </FormItem>
    <FormItem label="Partita IVA">
      <Input v-model="centro_form.piva"/>
    </FormItem>
    <FormItem label="Codice Fiscale">
      <Input v-model="centro_form.cf"/>
    </FormItem>
    <FormItem label="Telefono">
      <Input v-model="centro_form.telephone"/>
    </FormItem>
    <FormItem label="Fax">
      <Input v-model="centro_form.fax"/>
    </FormItem>
    <FormItem label="Email">
      <Input type="email" v-model="centro_form.email"/>
    </FormItem>
    <FormItem label="Indirizzo">
      <Input v-model="centro_form.addr_street"/>
    </FormItem>
    <FormItem label="Città">
      <Input v-model="centro_form.addr_city"/>
    </FormItem>
    <FormItem label="Provincia">
      <Input v-model="centro_form.provincia"/>
    </FormItem>
    <FormItem label="CAP">
      <Input v-model="centro_form.addr_zip"/>
    </FormItem>
    <FormItem label="Legale Rappresentate">
      <Input v-model="centro_form.legale_name"/>
    </FormItem>
    <FormItem label="Legale Rappresentate (email)">
      <Input v-model="centro_form.legale_email"/>
    </FormItem>
    <FormItem label="Indirizzo modulo registrazione soci">
      <i>tramite questo indirizzo sarà possibile far registrare i soci in totale autonomia, completare questo campo usando un nome indicativo composto solo di lettere o trattini -</i>
      <div>
        <Input v-model="centro_form.slug">
          <span slot="prepend">{{`https://${location.host}/#/registrazione/`}}</span>
        </Input>
        <i v-if="centro_form.slug">{{ `https://${location.host}/#/registrazione/${centro_form.slug}` }}</i>
      </div>
    </FormItem>
    <FormItem label="Modulo personalizzato">
      <i>carica la versione pdf (anteprima) e la versione documento con le etichette necessarie, esempio: <code>${nome-campo}</code></i>
      <div>
        <Button @click="pickFile(f => $set(centro_form, 'modulo_pdf', f))">
          Seleziona PDF {{ (centro_form.modulo_pdf || {}).name }}
        </Button>
        &nbsp;
        <Button @click="pickFile(f => $set(centro_form, 'modulo_doc', f))">
          Seleziona DOC {{ (centro_form.modulo_doc || {}).name }}
        </Button>
        <br>
        <a v-if="centro_form.module && centro_form.module.file_pdf" download="modulo.pdf" :href="`/moduli/${centro_form.module.file_pdf}`">Scarica PDF attuale</a>
        <a v-if="centro_form.module && centro_form.module.file" download="modulo.docx" :href="`/moduli/${centro_form.module.file}`">Scarica DOC attuale</a>
      </div>
    </FormItem>
    <FormItem label="Privacy policy">
      <wysiwyg v-model="centro_form.privacy_policy" />
    </FormItem>
    <FormItem label="Modalità">
      <RadioGroup :value="1*centro_form.has_comp" @input="centro_form.has_comp = !!$event; if(!centro_form.has_comp)centro_form.perc_amm=100">
        <Radio size="large" :label="0">
          &nbsp;&nbsp;
          Cassa
        </Radio>
        <Radio size="large" :label="1">
          &nbsp;&nbsp;
          Cassa e competenza
        </Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="" style="margin-top: -1rem" v-if="centro_form.has_comp">
      <div class="columns text-center" style="width: 70%; line-height: 2.2">
        <b>Percentuale di ammortamento:
          <input v-model="centro_form.perc_amm" style="padding: 0 0; width: 2.5rem; text-align:center" type="number"/>%</b>
        <input class="slider-color" style="" type="range" min="0" max="100" step="1" v-model="centro_form.perc_amm"/>
        <i style="">Trascina il pallino verde per cambiare la percentuale di ammortamento</i>
      </div>
    </FormItem>
    <FormItem>
      <Checkbox v-model="centro_form.has_iva" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita gestione IVA
      </Checkbox>
    </FormItem>
    <FormItem>
      <Checkbox v-model="centro_form.has_partita_doppia" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita movimenti in partita doppia
      </Checkbox>
    </FormItem>
    <!-- <FormItem>
      <Checkbox v-model="centro_form.has_comp" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita gestione per competenza
      </Checkbox>
    </FormItem> -->
    <FormItem>
      <Button @click="saveCentro()" type="primary" size="large" :loading="loading">Salva</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {
  props: [
    'size',
  ],

  data () {
    if (!('perc_amm' in this.$store.company)) {
      this.$set(this.$store.company, 'perc_amm', 100)
    }
    return {
      loading: false,
      centro_form: this._.clone(this.$store.company),
      location,
    }
  },

  mounted () {
    console.log('this.$refs.file', this.$refs.file)
    var canvas = this.$refs.logo_preview
    var form = this.centro_form
    let self = this
    this.$refs.file.onchange = function(e) {
      console.log('changed')
      function draw() {
        console.log('draw')
        let w = this.width
        let h = this.height
        let max_size = 350
        if (w > h && w > max_size) {
          let q = w / max_size
          w = max_size
          h = h/q
        } else if(h > w && h > max_size) {
          let q = h / max_size
          h = max_size
          w = w/q
        }

        canvas.width = w
        canvas.height = h
        var ctx = canvas.getContext('2d')
        ctx.drawImage(this, 0,0, w, h)
        self.$set(form, 'logo', canvas.toDataURL())
      }
      function failed() {
        alert("File non valido")
      }

      var img = new Image()
      img.onload = draw
      img.onerror = failed
      img.src = URL.createObjectURL(this.files[0])
    }
  },

  methods:{
    pickFile (on_ok, on_cancel) {
      var input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.click()
      input.onchange = e => {
        var f = e.target.files[0]
        if (!f) {
          on_cancel && on_cancel()
        } else {
          on_ok && on_ok(f)
        }
      }
    },

    saveCentro () {
      this.loading = true
      var formData = this.formData(this.centro_form)
      this.$http.post("companies", formData).then(res => {
        this.$Message.success('Salvato')
        this.$set(this.$store, 'company', res.data)
        this.$emit('saved')
        this.centro_form = this._.clone(this.$store.company)
      }).finally(res => {
        this.loading = false
      })
    },
    formData(data, name, fd, mandatory) {
      fd = fd || new FormData()
      name = name || ''
      if (data && typeof data === 'object' && data.constructor.name != 'File') {
        let is_array = data.constructor.name == 'Array'
        console.log('data is array?', name, _.cloneDeep(data), is_array)
        if (Object.values(data).length == 0) {
          this.formData('', name, fd)
        } else {
          for (var index in data) {
            var value = data[index]
            if (name == '') {
              this.formData(value, index, fd, is_array)
            } else {
              this.formData(value, name + '[' + index + ']', fd, is_array)
            }
          }
        }
      } else if (typeof data == 'boolean') {
        fd.append(name, data ? 1 : 0)
        console.log('appending', name, data ? 1 : 0)
      } else if (data === null || data === undefined) {
      } else if (data !== undefined && typeof data != 'function') {
        fd.append(name, data)
        console.log('appending', name, data)
      } else if (mandatory) {
        fd.append(name, '')
        console.log('appending', name, '')
      }
      return fd
    },

  },
}
</script>

<style lang="css">
</style>
79u
